<template lang="html">
  <div class="pms-modal">
    <div @click="$emit('close')" class="pms-modal-background"></div>
    <div class="pms-modal-dialogue container container--sm">
      <div class="card is-grey-extra-light">
        <button class="pms-modal-close dismiss" @click="$emit('close')" data-toggle="dismiss"></button>
        <div class="card-header">
          <h2>{{ $t('marketoModal.title', {expName: name}) }}</h2>
          <h3>{{ $t('marketoModal.subHeading', {expName: name}) }}</h3>
        </div>
        <div class="card-content">
          <div v-if="isFormLoading"  style="width: 100%;" class="form-spinner">
            <img style="max-width:64px;" src="//resources.siteminder.com/services/pms-finder/static/loading.gif" alt="">
          </div>
          <form class="mktoForm" id="mktoForm_4099"></form>
          <p class="text-left form-disclaimer lead text-grey" v-html="$t('marketoModal.formDisclaimer')"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  name: "modal",
  props: ["name", "email", "marketoCountry", "badge"],

  data() {
    return {
      isFormLoading: true,
      formLang: this.$i18n.locale,
      formTranslations: {
        en: {
          FirstName: {
            placeholder: "Enter your first name",
            validation: "Please enter your first name",
            submit: "Submit"
          },
          LastName: {
            placeholder: "Enter your last name",
            validation: "Please enter your last name"
          },
          Email: {
            placeholder: "Enter your email address",
            validation: "Please enter a valid email address"
          },
          Phone: {
            placeholder: "Enter your phone number",
            validation: "Please enter a valid phone number"
          },
          Company: {
            placeholder: "Enter your property name",
            validation: "Please enter your property/company name"
          },
          PMS_Marketo__c: {
            placeholder: "Enter your existing PMS (if you have one)",
          },
          Number_of_rooms__c: {
            placeholder: "Enter your number of rooms",
            validation: "Please enter a number (max 4-digits)"
          },
          Referrer_Name__c: {
            placeholder: "Referrer Name"
          },
          findanExpertQuestion1: {
            label: "Do you need the Expert to travel to your location?"
          },
          businessType: {
            label: "Are you a SiteMinder customer?",
            options: {
              '': "Select ...",
              Yes: "Yes",
              No: "No"
            }
          },
          sMGDPRConsent: {
            placeholder:
            "By clicking you agree to allow SiteMinder to periodically send you newsletters, webinar invites, industry thought leadership and offers, and otherwise use your data in accordance with our <a href='https://siteminder.com/legal/privacy' target='_blank' rel='noopener noreferrer'>privacy policy</a>.  You can withdraw your consent at any time by clicking unsubscribe on all our emails or in our website footer.",
            validation:
            "You need to consent before we can proceed with your request."
          }
        },
        de: {
          FirstName: {
            placeholder: "Geben Sie Ihren Vornamen an.",
            validation: "Bitte geben Sie Ihren Vornamen ein",
            submit: "Abschicken"
          },
          LastName: {
            placeholder: "Geben Sie Ihren Nachnamen an",
            validation: "Bitte geben Sie Ihren Nachnamen an"
          },
          Email: {
            placeholder: "Geben Sie Ihre E-Mail-Adresse an",
            validation: "E-Mail-Adresse eingeben. example@yourdomain.com"
          },
          Phone: {
            placeholder: "Geben Sie Ihre Telefonnummer an",
            validation: "Dies muss eine Telefonnummer sein. 1111 111111"
          },
          Company: {
            placeholder: "Geben Sie den Namen Ihrer Unterkunft an",
            validation: "Bitte geben Sie Ihren Hotelnamen ein"
          },
          PMS_Marketo__c: {
            placeholder: "Geben Sie den Namen Ihres PMS an (falls vorhanden)",
          },
          Number_of_rooms__c: {
            placeholder: "Geben Sie die Anzahl der Zimmer an",
            validation: "Bitte geben Sie eine Zahl (Max 4-stellig)"
          },
          Referrer_Name__c: {
            placeholder: "Name des Referrer"
          },
          businessType: {
            label: "Sind Sie schon Kunde bei uns?",
            options: {
              '': "Auswählen",
              Yes: "Ja",
              No: "Nein"
            }
          },
          sMGDPRConsent: {
            placeholder:
              "Indem Sie dieses Feld markieren, erklären Sie sich damit einverstanden, regelmäßig Newsletter, Einladungen zu Webinaren und Experten-Meinungen sowie Angebote von SiteMinder zu erhalten. Zusätzlich erlauben Sie uns, Ihre Daten gemäß unseren Datenschutzrichtlinien zu verwenden. Sie können Ihre Zustimmung jederzeit widerrufen, indem Sie sich über die dafür vorgesehene Funktion in unseren E-Mails oder in der Fußzeile unserer Webseite abmelden.",
            validation:
              "Sie müssen den Bedingungen zustimmen, bevor wir Ihre Anfrage bearbeiten können."
          }
        },
        es: {
          FirstName: {
            placeholder: "Introduzca su nombre",
            validation: "¿Cómo te llamas?",
            submit: "Enviar"
          },
          LastName: {
            placeholder: "Introduzca sus apellidos",
            validation: "Por favor, introduce tus apellidos"
          },
          Email: {
            placeholder: "Introduzca su correo electrónico",
            validation: "Introduce un correo electrónico. example@yourdomain.com"
          },
          Phone: {
            placeholder: "Introduzca su número de teléfono",
            validation: "Debe ser un número de teléfono. 111 111 111"
          },
          Company: {
            placeholder: "Introduzca el nombre de su establecimiento",
            validation: "¿Cómo se llama tu alojamiento?"
          },
          PMS_Marketo__c: {
            placeholder: "Introduzca el nombre de su sistema de gestión hotelera actual (si tiene)",
          },
          Number_of_rooms__c: {
            placeholder: "Introduzca el número de habitaciones",
            validation: "Por favor, introduce un número (máximo de 4 dígitos)"
          },
          Referrer_Name__c: {
            placeholder: "Nombre de la persona que le recomendó"
          },
          businessType: {
            label: "¿Es cliente de SiteMinder?",
            options: {
              '': "Seleccionar",
              Yes: "Sim",
              No: "Não"
            }
          },
          sMGDPRConsent: {
            placeholder:
            "Al hacer clic en el botón, aceptas que SiteMinder te envíe periódicamente boletines informativos, invitaciones a seminarios web, ofertas e información especializada sobre el sector, así como el uso de tus datos para cualquier otro fin que cumpla nuestra política de privacidad. Puedes retirar tu consentimiento en cualquier momento haciendo clic en «cancelar mi suscripción» en nuestros correos electrónicos o en el pie de página de nuestra página web.",
            validation:
            "You need to consent before we can proceed with your request."
          }
        },
        it: {
          FirstName: {
            placeholder: "Nome",
            validation: "Inserire il nome",
            submit: "Invia"
          },
          LastName: {
            placeholder: "Cognome",
            validation: "Inserire il cognome"
          },
          Email: {
            placeholder: "Indirizzo e-mail",
            validation: "Inserire un indirizzo e-mail valido"
          },
          Phone: {
            placeholder: "Numero di telefono",
            validation: "Inserire un numero di telefono valido"
          },
          Company: {
            placeholder: "Nome della struttura",
            validation: "Inserire il nome della proprietà"
          },
          PMS_Marketo__c: {
            placeholder: "Sistema di gestione della proprietà in utilizzo (se applicabile)",
          },
          Number_of_rooms__c: {
            placeholder: "Numero di camere",
            validation: "Inserire un numero (max 4 cifre)"
          },
          Referrer_Name__c: {
            placeholder: "Nome di chi ha raccomandato il servizio"
          },
          businessType: {
            label: "Sei un cliente di SiteMinder?",
            options: {
              '': "Seleziona",
              Yes: "Sì",
              No: "No"
            }
          },
          sMGDPRConsent: {
            placeholder:
            "Cliccando qui autorizzi SiteMinder a inviarti periodicamente newsletter con offerte, inviti a webinar e novità del settore, nonché a usare i tuoi dati in conformità all'informativa sulla privacy. È possibile revocare il consenso in qualsiasi momento cliccando sul link di cancellazione, disponibile nelle e-mail inviate da SiteMinder, oppure in fondo al sito web.",
            validation:
            "You need to consent before we can proceed with your request."
          }
        },
        pt: {
          FirstName: {
            placeholder: "Introduza o seu nome",
            validation: "Por favor, introduza o seu nome",
            submit: "Enviar"
          },
          LastName: {
            placeholder: "Introduza o seu sobrenome",
            validation: "Por favor, introduza o seu apelido"
          },
          Email: {
            placeholder: "Introduza o seu e-mail",
            validation: "Presidente executivo/Proprietário"
          },
          Phone: {
            placeholder: "Introduza o seu número de telefone",
            validation: "Por favor, introduza um número de telefone válido"
          },
          Company: {
            placeholder: "Introduza o nome do seu estabelecimento",
            validation: "Digite o nome da sua propriedade"
          },
          PMS_Marketo__c: {
            placeholder: "Introduza o seu sistema de gestão hoteleira existente (caso tenha um)",
          },
          Number_of_rooms__c: {
            placeholder: "Introduza o número de quartos",
            validation: "Por favor, introduza um número (Máx. 4 dígitos)"
          },
          Referrer_Name__c: {
            placeholder: "Nome da pessoa que recomendou o serviço"
          },
          businessType: {
            label: "É um cliente SiteMinder?",
            options: {
              '': "Selecionar",
              Yes: "Sim",
              No: "Não"
            }
          },
          sMGDPRConsent: {
            placeholder:
            "Ao assinalar esta caixa concorda em dar permissão à SiteMinder para lhe enviar periodicamente boletins informativos, convites para webinários, ofertas e liderança no sector, bem como usar os seus dados em conformidade com a nossa política de privacidade. Pode suspender o seu consentimento a qualquer altura clicando na secção cancelar inscrição, incluída em todos os nossos e-mails ou no rodapé do nosso site.",
            validation:
            "You need to consent before we can proceed with your request."
          }
        },
        fr: {
          FirstName: {
            placeholder: "Indiquez votre prénom",
            validation: "Veuillez indiquer votre Prénom",
            submit: "Envoyer"
          },
          LastName: {
            placeholder: "Indiquez votre nom",
            validation: "Entrez votre nom s'il vous plait"
          },
          Email: {
            placeholder: "Indiquez votre adresse e-mail",
            validation: "Saisissez une adresse électronique valide. example@yourdomain.com"
          },
          Phone: {
            placeholder: "Indiquez votre numéro de téléphone",
            validation: "Format \"numéro de téléphone\" obligatoire. 01 11 11 11 11"
          },
          Company: {
            placeholder: "Indiquez le nom de votre établissement",
            validation: "Veuillez indiquer le nom de votre établissement"
          },
          PMS_Marketo__c: {
            placeholder: "Indiquez le nom de votre PMS (si vous en avez déjà un)",
          },
          Number_of_rooms__c: {
            placeholder: "Indiquez votre nombre de chambres",
            validation: "S'il vous plaît entrez un numéro (max 4 chiffres)"
          },
          Referrer_Name__c: {
            placeholder: "Nom de la personne qui a recommandé le service"
          },
          businessType: {
            label: "Êtes-vous client·e de SiteMinder ?",
            options: {
              '': "Sélectionner",
              Yes: "Oui",
              No: "Non"
            }
          },
          sMGDPRConsent: {
            placeholder:
            "En cochant cette case, vous autorisez SiteMinder et ses partenaires à vous envoyer ponctuellement des newsletters, des invitations à des webinaires, des informations sur le secteur ou encore des offres promotionnelles. Vous l'autorisez également à utiliser vos données conformément à notre politique de confidentialité. Vous pouvez retirer votre consentement à tout moment en cliquant sur « Se désabonner » au bas de nos e-mails ou de notre site web.",
            validation:
            "You need to consent before we can proceed with your request."
          }
        }
      }
    };
  },

  mounted() {
    this.triggerModalClose();
    this.loadForm();
  },
  methods: {
    loadForm() {
      const mktoForms = window.MktoForms2;
      if (!mktoForms) {
        console.log("mktoForms not found");
        return;
      }
      mktoForms.loadForm("//sm.siteminder.com", "994-UJA-976", 4099, () => {
        this.isFormLoading = false;
      });
      mktoForms.whenReady(form => {
        var formEl = form.getFormElem()[0],
          ANCESTORS_STOR = ".mktoFormRow, .mktoFormCol",
          INPUTS_STOR = "INPUT, SELECT, TEXTAREA, BUTTON",
          attrTag = "data-wrapper-for",
          _forEach = Array.prototype.forEach;

        // utility fn: tag outer wrapper DIVs with their inner inputs' names to make them seekable
        (function tagMktoWrappers(formEl) {
          _forEach.call(formEl.querySelectorAll(ANCESTORS_STOR), function(
            ancestor
          ) {
            ancestor.setAttribute(attrTag, "");
            _forEach.call(ancestor.querySelectorAll(INPUTS_STOR), function(
              input
            ) {
              var currentTag = ancestor.getAttribute(attrTag);
              ancestor.setAttribute(
                attrTag,
                [
                  currentTag ? currentTag : "",
                  input.id,
                  input.name != input.id ? input.name : ""
                ]
                  .join(" ")
                  .trim()
              );
            });
          });
        })(formEl);

        var currentLang = this.formLang; // get current language setting (passed in URL or cookie or ... )

        // if (currentLang === 'en') {
        //   return;
        // }

        var translateMapEl = formEl.querySelector("#translateMap"), // get translations embedded in form rich text area
          translateMap = this.formTranslations,
          currentTranslations = translateMap[currentLang],
          submitButtonEl = formEl.querySelector('BUTTON[type="submit"]');

        // loop over translatables
        var fieldName,
          fieldTranslations,
          propertyName,
          propertyValue,
          translateTargetEl;
        for (fieldName in currentTranslations) {
          fieldTranslations = currentTranslations[fieldName];
          for (propertyName in fieldTranslations) {
            propertyValue = fieldTranslations[propertyName];
            switch (propertyName) {
              case "label":
                translateTargetEl = formEl.querySelector(
                  '[data-wrapper-for="' + fieldName + '"] LABEL'
                );
                if (translateTargetEl) {
                  document.documentElement.innerText
                    ? (translateTargetEl.lastChild.nodeValue = propertyValue)
                    : (translateTargetEl.lastChild.textContent = propertyValue);
                }
                break;
              case "validation":
                translateTargetEl = MktoForms2.$(
                  formEl.querySelector(
                    '[data-wrapper-for="' +
                      fieldName +
                      '"] .mktoFieldDescriptor'
                  )
                );
                if (!!translateTargetEl) {
                  translateTargetEl.data(
                    "mktoFieldDescriptor"
                  ).validationMessage = propertyValue;
                }
                break;
              case "placeholder":
                translateTargetEl = formEl.querySelector(
                  '[data-wrapper-for="' + fieldName + '"] INPUT'
                );
                if (translateTargetEl) {
                  translateTargetEl.setAttribute("placeholder", propertyValue);
                }
                break;
              case "options":
                translateTargetEl = formEl.querySelector(
                  '[data-wrapper-for="' + fieldName + '"] SELECT'
                );
                if (translateTargetEl) {
                  let opt = translateTargetEl.querySelectorAll('option[value]');
                  opt.forEach((option) => {
                    option.label = propertyValue[option.value]
                    //console.log(option.label);
                    //console.log(propertyValue);
                  })
                }
                break;
              case "submit":
                translateTargetEl = submitButtonEl;
                if (translateTargetEl) {
                  translateTargetEl.innerHTML = propertyValue;
                }
            }
          }
        }

        form.onSubmit((submittedForm) => {
          const vals = submittedForm.getValues();
          const date = new Date().toISOString().split('T')[0];
          submittedForm.vals({
            ...vals,
            uTMSource: this.name,
            findanExpertEmail: this.email,
            oPSUTMDate: date,
            Country: this.marketoCountry,
            Web_Language__c: this.formLang,
            SFGA__Web_Source__c: window.location.href,
            findanExpertName: this.name,
          })
        })
      });
    },

    triggerModalClose() {
      // Bind the escape key (Close with `esc`)
      document.addEventListener("keyup", e => {
        if (e.key === "Escape") {
          this.$emit("close");
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@siteminder/chameleon-variables";
.pms-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  z-index: 3000;
  overflow-y: scroll;
  visibility: visible;
  background: rgba(0, 0, 0, 0.3);

  .pms-modal-background {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    // visibility: visible;
    // opacity: 1;
    -webkit-transition: 4s ease opacity;
    transition: 4s ease opacity;
  }

  .pms-modal-close {
    position: absolute;
    cursor: pointer;
    background: white;
    top: 10px;
    right: 10px;
    z-index: 3;
    // opacity: 0;
    transition: 0.5s ease all;
    &:before,
    &:after {
      background: darken(white, 70%);
    }
  }
  .pms-modal-dialogue {
    padding: 0 0.5rem;
    margin-top: 10vh;
    @media #{$mobile} {
      margin-top: 1vh;
    }
    margin-bottom: 2em;
    position: relative;
    z-index: 2;
    transform: translateY(40px);
    opacity: 1;
    transition: 0.5s ease all;

    .card {
      position: relative;
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  .form-disclaimer {
    padding: 1.5em 10px 0;
  }
  .form-spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    background: white;
    z-index: 1;
    height:100%;

    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>
<style lang="scss">
form.mktoForm {
  font-family: Lato, Helvetica, Arial, sans-serif !important;
  width: 100% !important;
  // .mktoFormRow:nth-child(8), .mktoFormRow:nth-child(9) {
  //   display: none !important;
  // }
  [data-wrapper-for="sMGDPRConsent"], [data-wrapper-for="countrywCode"] {
    display: none !important;
  }

  .mktoFieldDescriptor[data-wrapper-for="businessType"],
  .mktoFieldDescriptor[data-wrapper-for="findanExpert1"] {
    display: inline-block;
    width: 100%;

    label[for="businessType"],
    label[for="findanExpertQuestion1"] {
    border-radius: 50%;
    width: 18px;
    height: 18px;
    margin-left: 0;
    &:after {
      height: 10px;
      left: 6px;
    }
  }

    .mktoLogicalField {
      left: 0;
      width: auto!important;
    }
  }
  .mktoLabel {
    display: none;
    &[for="businessType"],
    &[for="findanExpertQuestion1"] {
      display: inline-block;
      font-size: 1.2em;
      width: auto!important;
      padding-left: 15px;
      color: #005780;
      &:hover {
        color: #008bce;
        cursor: pointer;
      }

      .mktoAsterix {
        display: none;
      }
    }
  }
  select {
    padding-left: 15px !important;
  }
  .mktoAsterix {
    order: 1;
    color: #bc192a;
    margin-left: 0;
    margin-right: 4px;
    display: inline;
  }
  .mktoOffset {
    display: none;
  }
  .mktoRequiredField label.mktoLabel {
    font-weight: normal;
  }
  .mktoFieldDescriptor.mktoFormCol {
    margin-bottom: 0 !important;
  }
  div.mktoFormCol,
  div.mktoFieldWrap {
    float: none;
  }
  .mktoCheckboxList {
    position: absolute;
    left: 40%;
  }
  .mktoFormRow {
    font-size: 14px;
    font-family: Lato, sans-serif;
    margin-bottom: 10px;
  }
  .mktoClear {
    display: none;
  }
  .mktoFieldWrap {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    .mktoGutter {
      height: 0.4em;
      display: none;
    }
    label {
      // display: none;
      flex: 1;
    }
    input,
    select {
      margin-top: 4px;
      flex: auto;
    }
  }
  .mktoErrorMsg {
    color: #bc192a;
    font-size: 12px;
    line-height: 1;
    padding-top: 5px;
    padding-left: 2px;
  }
  .mktoButtonRow {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-end;
    margin-top: 25px;
  }
  .mktoButtonWrap.mktoSimple {
    margin-left: 0 !important;
    max-width: none !important;
    width: 100% !important;
  }
  .mktoButton {
    width: 100% !important;
  }
  .mktoButtonWrap.mktoSimple .mktoButton {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    border: 1px solid #dcdfe6;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    -webkit-transition: 0.1s;
    transition: 0.1s;
    text-decoration: none !important;
    padding: 10px 20px;
    font-size: 14px;
    font-weight: 500;
    border-radius: 4px;
    height: 40px;
    color: #fff;
    background-color: #007dbb;
    border-color: #007dbb;
    background-image: none;
    width: 100%;
    &:focus,
    &:hover {
      background: #006496;
      border-color: #006496;
      color: #fff;
      outline: 0;
    }
    &:active {
      background: #0071a8;
      border-color: #0071a8;
      color: #fff;
      outline: 0;
    }
  }
  input[type="text"],
  input[type="url"],
  input[type="email"],
  input[type="tel"],
  input[type="number"],
  input[type="date"],
  select {
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    border-top-color: rgb(220, 223, 230);
    border-right-color: rgb(220, 223, 230);
    border-bottom-color: rgb(220, 223, 230);
    border-left-color: rgb(220, 223, 230);
    box-sizing: border-box;
    width: 100% !important;
    color: #606266;
    display: inline-block;
    font-size: inherit !important;
    height: 34px !important;
    line-height: 34px;
    outline: 0;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    &:hover {
      border-color: #c0c4cc;
    }
    &:focus {
      border-color: #007dbb;
      outline: 0;
    }
    @media only screen and (max-width: 768px) {
      font-size: 16px !important;
    }
  }
  select {
    cursor: pointer;
  }
  input[type="checkbox"] {
    opacity: 0;
    outline: 0;
    position: absolute;
    margin: 0;
    width: 0;
    height: 0;
    z-index: -1;
  }
  input[type="checkbox"] + label {
    cursor: pointer;
    display: inline-block;
    position: relative;
    border: 1px solid #dcdfe6;
    border-radius: 2px;
    box-sizing: border-box;
    width: 14px;
    height: 14px;
    background-color: #fff;
    z-index: 1;
    transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
      background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
    &:after {
      box-sizing: content-box;
      content: "";
      border: 1px solid #fff;
      border-left: 0;
      border-top: 0;
      height: 7px;
      left: 4px;
      position: absolute;
      top: 1px;
      transform: rotate(45deg) scaleY(0);
      width: 3px;
      transition: transform 0.15s cubic-bezier(0.71, -0.46, 0.88, 0.6) 50ms;
      transform-origin: center;
    }
  }
  input[type="checkbox"]:checked + label {
    background-color: #007dbb;
    border-color: #007dbb;
    &:after {
      transform: rotate(45deg) scaleY(1);
    }
  }
}
</style>
